import { slide as Menu } from 'react-burger-menu';
import styled from 'styled-components';
import React, { useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import SocialIcons from '../SocialIcons';


const StyledBurgerMenu = styled.div`
    display: none;

    @media(max-width:1119px) {
        display: block;
    }   

  /* Position and sizing of burger button */
  .bm-burger-button {
    position: relative;
    float: right;

    /* position: fixed; */
    
    width: 36px;
    height: 30px;    

    right: 20px;
    top: 25px;
  }

  /* Color/shape of burger icon bars */
  .bm-burger-bars {
    background: white;
  }

  /* Position and sizing of clickable cross button */
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  /* Color/shape of close button cross */
  .bm-cross {
    background: orange;
  }

  /* General sidebar styles */
  .bm-menu {
    background: #1b1b1b;
    padding: 2.5em 1.5em 0;
    font-size: 1.2em;
  }

  /* Morph shape necessary with bubble or elastic */
  .bm-morph-shape {
    fill: #373a47;
  }

  /* Wrapper for item list */
  .bm-item-list {
    color: #f9f9f9;
    padding: 0.8em;
  }

  /* Individual item */
  .bm-item {
    display: inline-block;
    font-weight: 400;
    padding-bottom: 10px;
    color: #f9f9f9;
  }
  a.bm-item:hover {
    color: #fc6435;
  }

  /* Иконки соцсетей под пунктами меню, отделены тонкой линией */
  .bm-social {
    display: flex !important;
    align-items: center;
    gap: 25px;
    margin-top: 15px;
    padding-top: 25px;
    border-top: 1px solid rgba(252, 100, 53, 0.6);

    img {
      display: block;
    }
  }

  /* Styling of overlay */
  .bm-overlay {
    background: rgba(0, 0, 0, 0) !important;
  }
`;


const BurgerMenu = (props) => {
    const [menuOpenState, setMenuOpenState] = useState(false);

    const closeburgerMenu = () => {
        setMenuOpenState(false)
    }

    const handleStateChange = (state) => {
        setMenuOpenState(state.isOpen)
    }

    return(
        <StyledBurgerMenu>
            <Menu 
                isOpen={ menuOpenState }
                onStateChange={(state) => handleStateChange(state)}
            >
                <Link to="/" onClick={closeburgerMenu}>HOME</Link>
                <Link to="/about/" onClick={closeburgerMenu}>ABOUT US</Link>                
                <Link to="/projects/" onClick={closeburgerMenu}>PROJECTS</Link>
                <Link to="/allnews/" onClick={closeburgerMenu}>NEWS</Link>
                <div className="bm-social">
                    <SocialIcons />
                </div>
            </Menu>
        </StyledBurgerMenu>
    );
}
 
export default BurgerMenu;
